import Modal from 'components/desktop/shared/modal';
import { IconChevronRight } from 'components/icons';
import { compact, isEmpty, map } from 'lodash';
import Link from 'next/link';

interface Props {
  vrLinks?: string[];
  onClose?: () => void;
}

const Vr360ViewerModal = ({ vrLinks, onClose }: Props) => {
  const links = compact(vrLinks);

  return (
    <Modal
      closable
      title='Danh sách link VR 360'
      className='fixed left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 overflow-hidden'
      onClose={onClose}
    >
      <div className='-m-[24px] space-y-[24px] p-[24px] w-[600px] max-h-[calc(100vh-200px)] overflow-y-auto'>
        {!isEmpty(links) ? (
          map(links, (vrLink, vrLinkIndex) => (
            <Link
              key={vrLinkIndex}
              href={vrLink}
              target='_blank'
              className='group border-stroke flex space-x-[4px] border-[1px] rounded-[8px] overflow-hidden duration-[400ms] hover:shadow-6'
            >
              <div className='max-h-[90px] w-[180px] flex items-center duration-[500ms] overflow-hidden'>
                <div className='relative h-full max-h-full w-full bg-primary overflow-hidden'>
                  <img
                    src={'/images/vr360.webp'}
                    alt={'vr360.webp'}
                    loading='lazy'
                    className='h-full w-full object-center object-cover transition-all duration-[500ms] ease-in-out group-hover:scale-[1.05]'
                  />
                </div>
              </div>
              <div className='flex-1 flex flex-col justify-between p-[12px] overflow-hidden '>
                <span className='line-clamp-2 text-primary group-hover:underline break-words'>
                  {vrLink}
                </span>
                <div className='self-end flex item-center space-x-[6px]'>
                  <span className='font-[600] text-primary'>Xem chi tiết</span>
                  <IconChevronRight className='w-[20px] h-[20px] text-primary' />
                </div>
              </div>
            </Link>
          ))
        ) : (
          <span className='text-text2 italic'>Không có</span>
        )}
      </div>
      <div className='h-[1px] w-full bg-stroke mt-[24px] mb-[11px]' />
      <div className='flex justify-end -mb-[8px]'>
        <button
          type='button'
          className='min-w-[140px] rounded-[6px] bg-[#f0f0f0] py-[11px] px-[19px] font-[600] duration-[200ms] hover:bg-stroke'
          onClick={onClose}
        >
          Hủy
        </button>
      </div>
    </Modal>
  );
};

export default Vr360ViewerModal;
